import { mapActions } from 'vuex'
import { REFERENCE_CLEAR, REFERENCE_DETAILS } from '@/store/types'

export default
{
	props:
	{
		referenceNumber:
		{
			type:     String,
			required: true,
		},
	},

	watch:
	{
		referenceNumber:
		{
			immediate: true,

			handler(referenceNumber)
			{
				return this.loadReference({ referenceNumber })
			},
		},
	},

	methods:
	{
		...mapActions
		({
			clearReference: REFERENCE_CLEAR,
			loadReference:  REFERENCE_DETAILS,
		}),
	},

	beforeDestroy()
	{
		this.clearReference()
	},
}